// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7557":"895f0ab6","8322":"9169f44c"}[chunkId] + ".chunk.css";
};